import React from 'react';
import { connect } from 'react-redux';
import { defaultListProps } from '~constants/config';
import {
  List,
  TextField,
  FunctionField,
  EditButton,
  DeleteWithConfirmButton,
  CreateButton,
  showNotification,
  translate
} from 'react-admin';
import Button from '@material-ui/core/Button';
import CachedIcon from '@material-ui/icons/Cached';
import CustomDatagrid from '~components/CustomDatagrid';
import api from '~config/api';
import RecomputeStatusBanner, { markRecomputeStarted } from '~components/RecomputeStatusBanner';

function RecomputeMetricsButtonBase({ dispatch, translate: t }) {
  const handleRecompute = () => {
    api.post('/metrics/recompute-all/').then(response => {
      if (response.ok) {
        markRecomputeStarted();  // show the in-progress banner immediately
        dispatch(showNotification(t('metrics.recomputeStarted')));
      } else {
        dispatch(showNotification(t('metrics.recomputeError'), 'warning'));
      }
    });
  };

  return (
    <Button color="primary" onClick={handleRecompute}>
      <CachedIcon style={{ marginRight: 8 }} fontSize="small" />
      {t('buttons.recomputeMetrics')}
    </Button>
  );
}

const RecomputeMetricsButton = connect()(translate(RecomputeMetricsButtonBase));

function MetricListActions(props) {
  return (
    <>
      <RecomputeMetricsButton {...props} />
      <CreateButton basePath={props.basePath} />
    </>
  );
}

function MetricList({ ...props }) {
  return (
    <>
      <RecomputeStatusBanner />
      <List {...defaultListProps} {...props} actions={<MetricListActions />}>
        <CustomDatagrid rowClick="edit">
          <TextField source="id" />
          <TextField source="name" />
          <TextField source="unit" />
          <TextField source="category" />
          <FunctionField label="Actualización" render={r => r.manual ? 'Manual' : 'Automática'} />
          <DeleteWithConfirmButton label="" />
          <EditButton label="" />
        </CustomDatagrid>
      </List>
    </>
  );
}

export default MetricList;
